module.exports = __webpack_public_path__ + "static/media/Pratyay_Dhond.aa2f471f.jpeg";